import classNames from "classnames";
import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/sharp-regular-svg-icons";

import styles from "./card-button.module.scss";

type ButtonProps = Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  "type" | "children" | "className"
>;

type CardButtonProps = ButtonProps & {
  title: string;
  description: string;
  isSelected?: boolean;
};

const CardButton = ({
  title,
  description,
  isSelected,
  ...otherButtonProps
}: CardButtonProps) => (
  <button
    {...otherButtonProps}
    className={classNames(styles.button, {
      [styles.selected]: isSelected,
    })}
    type="button"
    name={title}
  >
    <div className={styles.titleContainer}>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={faCheck} />
      </div>
      <div className={styles.title}>{title}</div>
    </div>
    <div className={styles.description}>{description}</div>
  </button>
);

export default CardButton;
